"use client";
import React from "react";
import EventSlider from "./EventSlider";
import type { EventType } from "@/app/types/event";
import dayjs from "dayjs";
import { useTranslations } from "next-intl";
import { usePlatform } from "@/app/hooks/usePlatform";

const Events = ({
  data,
  type,
}: {
  data: EventType[];
  type: "flights" | "hotels";
}) => {
  const t = useTranslations("Events");

  const platefrom = usePlatform();

  return (
    data.length > 0 &&
    platefrom !== "ios" &&
    platefrom !== "android" && (
      <section className="container mx-auto py-6 sm:my-10 mt-6">
        <div className="">
          <h3 className="font-switzer text-sleap-gray-950 sm:text-4xl text-[28px] font-bold leading-8 mb-0">
            {t("heading")}
          </h3>
          <p className="mb-0 mt-2 sm:text-base text-sm font-switzer font-medium dark:text-sleap-gray-100 text-sleap-gray-950">
            {t("description")}
          </p>
        </div>
        <EventSlider data={data} type={type} />
      </section>
    )
  );
};

export default Events;
